class ArgCallerType
{
	static FormModule = "FormModule";
	static StringEditor = "StringEditor";
	static MainMenu = "MainMenu";
}



// WEBPACK FOOTER //
// ./src/formItem/ArgCallerType.js